/* eslint-disable sort-keys */
export const sizes = {
  borderRadius: "0.5rem",
  borderRadiusButton: ".5rem",
  borderRadiusRounded: "10000px",

  cardMargin: "3rem",

  cardMarginSmall: "1.5rem",

  contentMaxWidth: "140rem",

  landscapeWidth: 1350,
  menuHeight: "8rem",

  mobileWidth: 480,
  pagePadding: {
    landscape: "7rem",
    mobile: "2rem",
    portrait: "3rem",
  },
  portraitWidth: 824,
}
